var _style, _path, _g, _circle, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskG01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Task-G01_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 187.2 187.2",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Task-G01_svg__st1{enable-background:new}.Task-G01_svg__st2{fill:#aeaeae}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e1e0",
    d: "M187.2 93.6l-8.7 9.6 6.4 11.2-10.7 7.4 3.7 12.4-12 4.8.9 12.9L154 154l-2.1 12.8-12.9-.9-4.8 12-12.4-3.7-7.4 10.7-11.2-6.4-9.6 8.7-9.6-8.7-11.2 6.4-7.4-10.7-12.4 3.7-4.8-12-13 .9-2-12.8-12.8-2.1.9-12.9-12-4.8 3.6-12.4-10.6-7.4 6.4-11.2L0 93.6 8.7 84 2.3 72.8l10.6-7.4L9.3 53l12-4.8-.9-13 12.8-2 2-12.8 13 .9 4.8-12 12.4 3.6 7.4-10.6L84 8.7 93.6 0l9.6 8.7 11.2-6.4 7.4 10.6 12.4-3.6 4.8 12 12.9-.9 2.1 12.8 12.8 2-.9 13 12 4.8-3.7 12.4 10.7 7.4-6.4 11.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Task-G01_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Task-G01_svg__st2",
    d: "M84.9 56.1h14.3v50.3h-9.5V65.1H79.4l5.5-9z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6,
    cy: 93.6,
    r: 73.5,
    fill: "none",
    stroke: "#aeaeae",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "Task-G01_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Task-G01_svg__st2",
    d: "M59.9 121h11.9v4h-3.9v17.5h-4.2V125h-3.8v-4zM81.2 121h4.2l8.3 21.5h-4.3l-1.7-4.4h-8.8l-1.8 4.4h-4.3l8.4-21.5zm2.1 5.7l-2.9 7.4h5.8l-2.9-7.4zM108.1 123.9l-3 2.7c-1.1-1.5-2.2-2.2-3.3-2.2-.5 0-1 .1-1.3.4-.3.3-.5.6-.5 1s.1.7.4 1c.3.4 1.3 1.4 3 2.8 1.6 1.3 2.5 2.1 2.8 2.5.8.8 1.4 1.6 1.8 2.4s.5 1.6.5 2.5c0 1.8-.6 3.2-1.8 4.4-1.2 1.2-2.8 1.7-4.8 1.7-1.5 0-2.9-.4-4-1.1s-2.1-1.9-2.9-3.5l3.4-2.1c1 1.9 2.2 2.9 3.6 2.9.7 0 1.3-.2 1.8-.6.5-.4.7-.9.7-1.4 0-.5-.2-1-.5-1.5-.4-.5-1.2-1.2-2.4-2.2-2.3-1.9-3.9-3.4-4.5-4.4-.7-1-1-2.1-1-3.1 0-1.5.6-2.8 1.7-3.8 1.1-1.1 2.5-1.6 4.2-1.6 1.1 0 2.1.2 3.1.7s1.8 1.2 3 2.5zM112.4 121h4.1v7.4l5.8-7.4h4.9l-7.5 9.6 8.3 11.9h-4.9l-6.6-9.6v9.6h-4.1V121z"
  }))));
}
export default SvgTaskG01;